import React from "react";
import { FaStar } from "react-icons/fa";
import { BsDash } from "react-icons/bs";
import Navbar from "../components/Navbar";
import Fotter from "../components/Fotter";
import { Link } from "react-router-dom";

const data = [
  { label: "White Line", range: "1-10", stars: 0, img: "./stars/white.png" },
  {
    label: "Silver Line",
    range: "11-20",
    stars: 0,
    color: "silver",
    img: "./stars/silver.png",
  },
  {
    label: "Golden Line",
    range: "21-30",
    stars: 0,
    color: "gold",
    img: "./stars/gold.png",
  },
  {
    label: "White Line with white star",
    range: "31-60",
    stars: 1,
    color: "white",
    img: "./stars/13.png",
  },
  {
    label: "Silver Line with silver star",
    range: "61-90",
    stars: 1,
    color: "silver",
    img: "./stars/12.png",
  },
  {
    label: "Golden Line with golden star",
    range: "91-120",
    stars: 1,
    color: "gold",
    img: "./stars/11.png",
  },

  {
    label: "White Line with two white stars",
    range: "121-150",
    stars: 2,
    color: "white",
    img: "./stars/21.png",
  },
  {
    label: "Silver Line with two silver stars",
    range: "151-180",
    stars: 2,
    color: "silver",
    img: "./stars/22.png",
  },
  {
    label: "Golden Line with two golden stars",
    range: "181-210",
    stars: 2,
    color: "gold",
    img: "./stars/24.png",
  },
  {
    label: "Golden Line with 3 golden stars",
    range: "211-300",
    stars: 3,
    color: "gold",
    img: "./stars/33.png",
  },
  {
    label: "Golden Line with 4 golden stars",
    range: "301-400",
    stars: 4,
    color: "gold",
    img: "./stars/45.png",
  },
  {
    label: "Golden Line with 5 golden stars",
    range: "401-500",
    stars: 5,
    color: "gold",
    img: "./stars/55.png",
  },
  {
    label: "Golden Line with 6 golden stars",
    range: "501-1000",
    stars: 6,
    color: "gold",
    img: "./stars/6.png",
  },
  {
    label: "Golden Line with 7 golden stars",
    range: "1001-2000",
    stars: 7,
    color: "gold",
    img: "./stars/7.png",
  },
  {
    label: "Golden Line with 8 golden stars",
    range: "2001-3000",
    stars: 8,
    img: "./stars/8.png",
    color: "gold",
  },
  {
    label: "Golden Line with 9 golden stars",
    range: "3001-4000",
    stars: 9,
    img: "./stars/9.png",
    color: "gold",
  },
  {
    label: "Golden Line with 10 golden stars",
    range: "4001-5000",
    stars: 10,
    color: "gold",
    img: "./stars/10.png",
  },
];

const ReviewDetailList = () => {
  return (
    <>
      <Navbar />

      <div className="page-info">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="info">
                <Link to="/">
                  <p>HOME</p>
                </Link>
                <span>/</span>
                <p>
                  The amount of smiley faces should be reflected on the symbol.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container" style={{ padding: "40px 0" }}>
        <div className="row">
          <div className="col-12">
            <div
              style={{
                margin: "0 auto",
                background: "#fff",
                boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                borderRadius: "20px",
                padding: "20px",
                fontFamily: "DM Sans, sans-serif",
              }}
            >
              <h2
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                  marginBottom: "20px",
                }}
              >
                Here is the numbers of each symbol
              </h2>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                }}
              >
                {data.map((item, idx) => (
                  <div
                    key={idx}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      padding: "10px 15px",
                    }}
                  >
                    <div>
                      <div style={{ fontWeight: "700", fontSize: "14px" }}>
                        {item.label}
                      </div>
                      <div style={{ fontSize: "12px", color: "#666" }}>
                        {item.range}
                      </div>
                    </div>

                    <div
                      style={{
                        background: "#148eda",
                        minWidth: "80px",

                        borderRadius: "5px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "5px 10px",
                      }}
                    >
                      <img src={item.img} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Fotter />
    </>
  );
};

export default ReviewDetailList;
